import React from "react";

export default function WhyChoose() {
  return (
    <div className="why-choose-us">
      <div className="container">

        {/* Section Title */}
        <div className="row section-row align-items-center">
          <div className="col-lg-8 col-md-12">
            <div className="section-title">
              <h3 className="wow fadeInUp">Why Choose Us</h3>
              <h2
                className="text-anime-style-3"
                style={{ perspective: "400px" }}
              >
                Why choose us?
              </h2>
            </div>
          </div>
        </div>

        {/* Items */}
        <div className="row">
          <WhyItem
            delay="0.25s"
            img="/assets/images/icon-whyus-1.svg"
            title="Who we are"
            text="An outcomes-led organization of trusted innovators and in-house experts delivering excellence in Health-Tech and Pharma IT."
          />

          <WhyItem
            delay="0.5s"
            img="/assets/images/icon-whyus-2.svg"
            title="What we stand for"
            text="Trust, Privacy, Quality, Real Outcomes, Transparency, Measurable Impact, Accountability."
          />

          <WhyItem
            delay="0.75s"
            img="/assets/images/icon-whyus-3.svg"
            title="Our Mission"
            text="To make the Health and Pharma industry better by turning complex data into clear decisions using smart technology."
          />

          <WhyItem
            delay="0.75s"
            img="/assets/images/icon-whyus-3.svg"
            title="Our DNA"
            text="Driven by clinical insights, defined by product rigor, inspired by innovation, guided by evidence, and committed to reliable delivery."
          />
        </div>

      </div>
    </div>
  );
}

/* Reusable item */
function WhyItem({ img, title, text, delay }) {
  return (
    <div className="col-lg-6 col-md-6">
      <div
        className="why-choose-us-item wow fadeInUp"
        data-wow-delay={delay}
      >
        <div className="icon-box">
          <img src={img} alt={title} />
        </div>
        <h3>{title}</h3>
        <p>{text}</p>
      </div>
    </div>
  );
}
